import { useRef } from 'react';
import { useParams } from 'react-router-dom';
import { usePowerBiEmbed } from '../hooks/usePowerBiEmbed.js';

export default function DashboardView() {
  const { dashboardId } = useParams();
  const containerRef = useRef(null);
  const { status, error } = usePowerBiEmbed({ kind: 'dashboard', id: dashboardId, containerRef });

  return (
    <div className="embed-wrapper">
      {status === 'loading' && <EmbedSpinner />}
      {status === 'error' && <EmbedError error={error} />}
      <div ref={containerRef} className="embed-container" />
    </div>
  );
}

function EmbedSpinner() {
  return <div className="embed-overlay"><div className="spinner-border text-primary" /></div>;
}

function EmbedError({ error }) {
  return (
    <div className="embed-overlay">
      <div className="alert alert-danger">
        <strong>This content could not be loaded.</strong>
        <div className="small">{error?.message ?? error?.detailedMessage ?? ''}</div>
      </div>
    </div>
  );
}
